import Component from "../../lib/component";
import Tracker from "../../lib/tracker";
import {formattedExitCategory, formattedExitDestination} from "../external_link/exit_helpers";

export const ExternalFormConfig = {
    componentTypeKey: 'ExternalForm',
    baseHtmlClass: 'external_form',
    selector: 'form.external_form',

    datasetConfigKey: 'external_form__config',

    categoryPrefix: 'OUTBOUND_FORM',
    defaultMethod: 'GET',
    pageExitEventNameKey: 'PAGE_EXIT',
};

export class ExternalForm extends Component {

    constructor(id_or_element) {
        super({
            element: id_or_element,
            config: ExternalFormConfig
        });

        this.setDatasetConfig(ExternalFormConfig.datasetConfigKey);

        // TODO - use the `getTrackerOptions` helper function to extract these properties that are passed to the Tracker.
        this.isNativeApp = this.datasetConfig.hasOwnProperty('is_native_app') ? this.datasetConfig['is_native_app'] : null;
        this.nativeAppUrlScheme = this.datasetConfig.hasOwnProperty('native_app_url_scheme') ? this.datasetConfig['native_app_url_scheme'] : null;
        this.nativeEventHost = this.datasetConfig.hasOwnProperty('native_event_host') ? this.datasetConfig['native_event_host'] : null;
        this.nativeEventEndpoint = this.datasetConfig.hasOwnProperty('native_event_endpoint') ? this.datasetConfig['native_event_endpoint'] : null;

        this.tracker = new Tracker(window, document, {
            isNativeApp: this.isNativeApp,
            nativeAppUrlScheme: this.nativeAppUrlScheme,
            nativeEventHost: this.nativeEventHost,
            nativeEventEndpoint: this.nativeEventEndpoint
        });

        this.eventName = this.tracker.eventNames[ExternalFormConfig.pageExitEventNameKey];
        if (typeof this.eventName === 'undefined') console.warn("[ExternalForm] Event name could not be found! Available options are: ", this.tracker?.eventNames);

        this.element.addEventListener('submit', this.handleSubmit.bind(this));
    }

    handleSubmit(event) {
        this.trackExitEvent();
    }

    trackExitEvent() {
        if (!this.tracker || !this.tracker.eventTracker) return;
        if (!this.eventName) return;
        // console.log(`[ExternalForm] trackExitEvent(): eventName: ${this.eventName} `, this.getAnalyticsParameters());
        this.tracker.eventTracker(this.eventName, this.getAnalyticsParameters());
    }

    getAnalyticsParameters() {
        return {
            exit_category: this.getExitCategory(),
            exit_destination: this.getExitDestination()
        }
    }

    getExitCategory() {
        const category = this.element.getAttribute('data-external_category');
        return formattedExitCategory(ExternalFormConfig.categoryPrefix, category);
    }

    getExitDestination() {
        return formattedExitDestination(this.getUrl(), this.getMethod());
    }

    getUrl() {
        let url = this.getDatasetConfigValue('external_url');
        if (url == null) {
            this.element.getAttribute('data-external_url');
        }
        if (url == null) {
            url = this.element.getAttribute('action')
        }
        if (url == null) {
            url = ''
        }
        return url;
    }

    getMethod() {
        let method = this.element.getAttribute('method');
        if (method == null || method === '') {
            method = ExternalFormConfig.defaultMethod
        }
        return method.toUpperCase();
    }


}